export const resolveEquipmentListForCalendarRefresh = ({
  selectedList = [],
  backupSelectedList = [],
  bookingInstruments = [],
}) => {
  if (selectedList.length > 0) {
    return {
      equipmentList: selectedList,
      shouldPersistSelection: false,
    };
  }

  if (backupSelectedList.length > 0) {
    return {
      equipmentList: backupSelectedList,
      shouldPersistSelection: true,
    };
  }

  const equipmentList = bookingInstruments
    .map((instrument) => instrument.inventoryId)
    .filter(Boolean);

  return {
    equipmentList,
    shouldPersistSelection: equipmentList.length > 0,
  };
};

export const getCancelOperationStatus = ({ response, cancelOperation }) => {
  const isCancelAction = response?.operation === cancelOperation;

  return {
    isCancelSuccess: isCancelAction && Boolean(response?.success),
    isCancelFailure: isCancelAction && !response?.success,
  };
};
